
const qc = {
    adminAssessments: "adminAssessments",
    words: "words",
    languages: "languages",
    methods: "methods",
    users: "users",
    fluencyStats: "fluencyStats",
    correctWordsPerMinute: "correctWordsPerMinute",
    watingForMarkingCount: "watingForMarkingCount",
    wordDefFrequency: "wordDefFrequency",
    incorrectWordsFrequency: "incorrectWordsFrequency",
    fluencyDistribution: "fluencyDistribution",
    accuracyDistribution: "accuracyDistribution",
    abilitiesGroup: "abilitiesGroup",
    percentAccuracyDoughnutChart: "percentAccuracyDoughnutChart",
    factoredPercentAccuracyDoughnut: "factoredPercentAccuracyDoughnut",
    fluencyDoughnut: "fluencyDoughnut",
    fluencyReadingDoughnut: "fluencyReadingDoughnut",
    correctWordsPerMinuteDoughnut: "correctWordsPerMinuteDoughnut",
    newsletters: "newsletters",
    systemAreas: "systemAreas",
    newsletter: "newsletter",
    scoreRatingSemesters: "scoreRatingSemesters",
    factoredAccuracyDistribution: "factoredAccuracyDistribution",
    fluencyReadingDistribution: "fluencyReadingDistribution",
    correctWordsPerMinuteDistribution: "correctWordsPerMinuteDistribution",
    scoreRatingMethod: "scoreRatingMethod",
    assessment: "assessment",
    word: "word",
    exampleWordDefs: "exampleWordDefs",
    matchingLearning: "matchingLearning",
    accuracyStats: "accuracyStats",
    readingFluencyStats: "accuracyStats",
    performAssessment: "performAssessment",
    factoredAccuracyGraph: "factoredAccuracyGraph",
    factoredAccuracyStats: "factoredAccuracyStats",
    factoredAccuracyStats: "factoredAccuracyStats",
    testTaker: "testTaker",
    allGrades: "allGrades",
    categories: "categories",
    rating: "rating",
    getAudioFile: "getAudioFile",
    initAIServer: "initAIServer",
    whisper: "whisper",
    assessmentDef: "assessmentDef",
    assessmentDefs: "assessmentDefs",
    prices: "prices",
    allAssessmentDefs: "allAssessmentDefs",
    fluencyStats: "fluencyStats",
    fluencyReadingStats: "fluencyReadingStats",
    correctWordsPerMinute: "correctWordsPerMinute",
    fluencyGraph: "fluencyGraph",
    hesitationsStats: "hesitationsStats",
    factoredAccuracyStats: "factoredAccuracyStats",
    accuracyStatsByAssessment: "accuracyStatsByAssessment",
    tClassess: "tClassess",
    nestedWords: "nestedWords",
    vowelCodes: "vowelCodes",
    letterAddOns: "letterAddOns",
    letterDescriptions: "letterDescriptions",
    assessments: "assessments",
    getWithLastAssessments: "getWithLastAssessments",
    report: "report",
    testTakers: "testTakers",
    grades: "grades",
    dashboard: "dashboard",
    assessmentFrequency: "assessmentFrequency",
    assessmentFrequencyFactored: "assessmentFrequencyFactored",
    wordFrequency: "wordFrequency",
    assessmentAndWords: "assessmentAndWords"
}

export default qc